export default __webpack_public_path__ + "static/media/clinicX.c9381dc4.jpg";